export interface LoyaltyEducation {
  title: string;
  content: LoyaltyEducationContent;
  action: LoyaltyEducationAction;
}

export interface LoyaltyEducationContent {
  _type: LoyaltyEducationContentType;
}

export enum LoyaltyEducationContentType {
  POINTS,
  PROGRAM
}

export interface LoyaltyPointsEducation extends LoyaltyEducationContent {
  description: string;
  programFeatures: LoyaltyEducationSection[];
}

export interface LoyaltyProgramEducation extends LoyaltyEducationContent {
  perks: LoyaltyEducationPerks;
  joinProgramText: string;
}

export interface LoyaltyEducationSection {
  title: string;
  perks: LoyaltyEducationPerks;
  description: string;
}

export interface LoyaltyEducationPerks {
  descriptions: string[];
  icon: string;
}

export interface LoyaltyEducationAction {
  text: string;
  rfrr: string;
  href: string;
}
